import { Routes } from "../../../routes"

export const SidebarAdmin = () => {
  let results = {
    title: "admin",
    items: [
      {
        title: "users",
        icon: "fa fa-users",
        link: Routes.AdminUsers.path,
      },
      {
        title: "organizations",
        icon: "fa fa-sitemap",
        link: Routes.AdminOrganizations.path,
      },

      // {
      //   title: "reports",
      //   icon: "fa fa-chart-line",
      //   link: Routes.AdminReports.path,
      // },
    ],
  }
  return results
}

export const SidebarRegular = () => {
  let results = {
    title: "dataworker",
    items: [
      {
        title: "Dashboard",
        icon: "fa fa-chart-line",
        link: Routes.Dashboard.path,
      },
      {
        title: "WorkerCheck",
        icon: "fa fa-search",
        link: Routes.CheckProfile.path,
      },
      {
        title: "Plantilla de Personal",
        icon: "fa fa-folder",
        link: Routes.PersonalPage.path,
      },
      {
        title: "Destinos",
        icon: "fa fa-briefcase",
        link: Routes.Projects.path,
      },
      // {
      //   title: "Georeferencias",
      //   icon: "fa fa-map-location-dot",
      //   link: Routes.Georeferences.path,
      // },
      {
        title: "Gestión de Acceso Laboral",
        icon: "fa fa-check",
        link: "#",
        subItems: [
          // {
          //   title: "Validación del Representante Laboral",
          //   link: Routes.LaborAccessRequestProvider.path,
          // },
          {
            title: "Validación del Representante Laboral",
            link: Routes.CreateLaborAccessRequest.path,
          },
          // {
          //   title: "Validación del Representante Laboral",
          //   link: Routes.ValidationOfLaborRepresentative.path,
          // },

          {
            title: "Control de Solicitudes/Propietarios",
            link: Routes.OwnerRequestControl.path,
          },
          {
            title: "Control de Solicitudes/Representantes",
            link: Routes.EmployeeRequestControl.path,
          },
          {
            title: "Control de Accesos Aprobados",
            link: Routes.RequestControl.path,
          },
        ],
      },

      // {
      //   title: "Reportes",
      //   icon: "fa fa-exclamation",
      //   link: "#reports",
      //   subItems: [
      //     {
      //       title: "Incidentes",
      //       icon: "fa fa-circle-exclamation",
      //       link: Routes.Incidents.path,
      //     },
      //     {
      //       title: "Alertas de personal",
      //       icon: "fa fa-triangle-exclamation",
      //       link: Routes.Alerts.path,
      //     },
      //   ],
      // },
      {
        title: "Denuncias",
        icon: "fa fa-file-pen",
        link: Routes.Complains.path,
      },

      // {
      //   title: "reports",
      //   icon: "fa fa-chart-line",
      //   link: Routes.Reports.path,
      // },

      // {
      //   title: "settings",
      //   icon: "fa fa-cog",
      //   link: Routes.Settings.path,
      // },
    ],
  }
  return results
}
